<template>
  <div class="home">
        <v-subheader class="mt-7">MESSAGE TYPES</v-subheader>
    <v-card>
      <v-card-text>
        <p>Select the type messages you wish to receive. In order to receive notifications on your device, select [Request Notifications] </p>
       <v-list shaped  >
      <v-list-item-group
        v-model="fm.options"
        multiple
      >
        <template v-for="(item, i) in alertTypes">
          <v-divider
            v-if="!item"
            :key="`divider-${i}`"
          ></v-divider>

          <v-list-item
            v-else
            :key="item.key"
            :value="item.name"
            active-class="deep-purple--text text--accent-4"
            
          >
            <template v-slot:default="{ active, toggle }">
              <v-list-item-content>
                <v-list-item-title v-text="item.name"></v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                <v-checkbox
                 
                  :input-value="active"
                  :true-value="item.name"
                  color="deep-purple accent-4"
                  @click="updateAlertType(); toggle"
                ></v-checkbox>
              </v-list-item-action>
            </template>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>
      </v-card-text>
      <v-card-actions>
        <span class="flex-grow-1"></span>
    
    <v-btn v-if="claims.isUser" class="" @click="RequestMessaging">Request Notifications</v-btn>
      </v-card-actions>
      </v-card>
      <v-card>
        <v-card-text class="pa-4">
          <span v-if="setting"> {{setting.displayName}} </span>
          <!-- <span v-else>Settings Not Loaded</span> -->

        </v-card-text>
      </v-card>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import {messaging} from '../store/firebase';
//import validate from 'validate'
import fb from '../store/firebase.js';
export default {
  data(){
    return {
      // alertTypes:[],
      fm:{
        options:[]
      },
      uid:null,
      options:null,
     //isAlert: new validate({})
    }
  },
  methods:{
    ...mapActions(['setUserSetting']) ,
    RequestMessaging(){
         let self = this;
         messaging.requestPermission().then(function(){          
           return messaging.getToken();
         })
         .then(function(token){
          // console.log(token);
           console.log("Have permission", token);
           let ob = {
             topics : self.fm.options.reduce( (acc, itm)=>{ acc[itm] = true; return acc}, {} ),
             token: token
           }
           // self.sendTokenToServer(ob.id)
            console.log("request", ob, );
            self.$store.dispatch("RegisterNotications", ob)
         })
         .catch(function(err){
           console.log("Error Occured.", err)
         });
    },
     updateAlertType(){
         
        this.$store.dispatch("updateAlertTypes", this.fm.options)
           .then(function(doc){
             
           })
     }
  },
   computed:{
      ...mapState(['setting', 'user']),
    alertTypes(){
      let als = this.$store.getters.AlertTypes;
      let usrTopics = []
      this.$store.getters.UserRecord.then((doc)=>{
        let tops = doc.data().topics
        //fm.options  = ["Weather", "Traffic"]         
          this.fm.options.push(...Object.keys(tops) )       
       
      })
      return als
    },
      claims(){
         if(!this.$store.getters.Claims){
          return {isAdmin:false,isUser:true}
        }

         return this.$store.getters.Claims
       }
      
    
  },
  created(){
    },
    watch:{
      'fm.options':function(val){
        this.$store.dispatch("updateAlertTypes", this.fm.options)
      },
      'uid':function(uid){
        let self = this;
        if(!uid)return;
          fb.collection("users").doc(uid)
        .get()
         .then(function(d){
           if(!d.data)return;
           Object.keys(d.data().topics)
                  .forEach(n=> self.fm.options.push(n))
         });
      }
    },
  mounted(){
    let self = this;
    //this.alertTypes = this.$store.getters.AlertTypes;
    
    if(this.$store.getters.User){
      this.uid = this.$store.getters.User.uid;
      // this.setUserSetting(this.$store.getters.User.uid)
      // this.$bind("options", 
      // fb.collection("users").doc(this.$store.getters.User.uid)
      //   .then(op=>{
      //     if(!op.data)return;
      //      console.log("usersettings", op.data())
      //      op.data().topics.forEach(n=> self.fm.options.push(n))
            
      //    }))
 
    }
  }
}
</script>